// ViewCustomerLinks.jsx
import React, { useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ViewCustomerLinks.css';

const ViewCustomerLinks = () => {
  const { t } = useTranslation();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomers = async () => {
      const coffeeShopId = localStorage.getItem('coffee_shop_id');

      if (!coffeeShopId) {
        setLoading(false);
        return;
      }

      const q = query(
        collection(db, 'customers'),
        where('coffee_shop_id', '==', coffeeShopId)
      );

      const querySnapshot = await getDocs(q);
      const customerData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setCustomers(customerData);
      setLoading(false);
    };

    fetchCustomers();
  }, []);

  return (
    <div className="customer-links-container">
      <h1>{t('customer_links_title')}</h1>
      {loading ? (
        <p>{t('loading_customers')}</p>
      ) : customers.length === 0 ? (
        <p>{t('no_customers_found')}</p>
      ) : (
        <div className="table-responsive">
          <table>
            <thead>
              <tr>
                <th>{t('id')}</th>
                <th>{t('name')}</th>
                <th>{t('organization')}</th>
                <th>{t('token')}</th>
                <th>{t('customer_link')}</th>
                <th>{t('total_coffees')}</th>
                <th>{t('current_cycle')}</th>
                <th>{t('review_link')}</th>
              </tr>
            </thead>
            <tbody>
              {customers.map(customer => (
                <tr key={customer.id}>
                  <td>{customer.id}</td>
                  <td>{customer.name}</td>
                  <td>{customer.organization}</td>
                  <td>{customer.token}</td>
                  <td>
                    <a href={customer.customer_link} target="_blank" rel="noopener noreferrer">
                      {customer.customer_link}
                    </a>
                  </td>
                  <td>{customer.total_coffees || 0}</td>
                  <td>{customer.current_cycle_coffees || 0}</td>
                  <td>
                    <a href={`/review/${customer.token}`} target="_blank" rel="noopener noreferrer">
                      {t('leave_review')}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <button className="dashboard-btn" onClick={() => navigate('/dashboard')}>{t('back_to_dashboard')}</button>
    </div>
  );
};

export default ViewCustomerLinks;
